<div class="mb-2">
  <span class="secondary-details mb-2">{{ 'configuration.packageList.packagingConfiguration' | translate }}</span>
</div>

<div class="example-container" [formGroup]="packageDetails">
  <div formArrayName="data">
    <ng-container>
      <div class="custom-card">
        <table aria-describedby="package-table" mat-table [dataSource]="packageDataSource">
          <ng-container matColumnDef="number">
            <th id="noOfLineItem" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.number' | translate }}*</th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="packagingType">
            <th id="packagingType" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.packagingType' | translate }}*</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                [ngStyle]="{
                  'border-color': getPackageFormControlId(i, 'packagingType').errors
                    ? 'red'
                    : 'grey'
                }"
                type="text"
                class="form-control"
                formControlName="packagingType" />
            </td>
          </ng-container>

          <ng-container matColumnDef="packageHeight">
            <th id="packageHeight" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.packageHeight' | translate }}* (CM)</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                [matTooltipDisabled]="!getPackageFormControlId(i, 'packageHeight').errors"
                matTooltip="{{ 'configuration.packageList.toolTip.minimumValidation' | translate }}"
                [ngStyle]="{
                  'border-color': getPackageFormControlId(i, 'packageHeight').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                type="text"
                formControlName="packageHeight" />
            </td>
          </ng-container>

          <ng-container matColumnDef="packageLength">
            <th id="packageLength" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.packageLength' | translate }}* (CM)</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                [matTooltipDisabled]="!getPackageFormControlId(i, 'packageLength').errors"
                matTooltip="{{ 'configuration.packageList.toolTip.minimumValidation' | translate }}"
                [ngStyle]="{
                  'border-color': getPackageFormControlId(i, 'packageLength').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                type="text"
                formControlName="packageLength" />
            </td>
          </ng-container>
          <ng-container matColumnDef="packageWeight">
            <th id="packageWeight" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.packageWeight' | translate }}* (KG)</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                class="form-control"
                [matTooltipDisabled]="!getPackageFormControlId(i, 'packageWeight').errors"
                matTooltip="{{ 'configuration.packageList.toolTip.minimumValidation' | translate }}"
                [ngStyle]="{
                  'border-color': getPackageFormControlId(i, 'packageWeight').errors
                    ? 'red'
                    : 'grey'
                }"
                min="0"
                maxlength="15"
                formControlName="packageWeight" />
            </td>
          </ng-container>
          <ng-container matColumnDef="packageWidth">
            <th id="packageWidth" mat-header-cell *matHeaderCellDef>{{ 'configuration.packageList.packageWidth' | translate }}* (CM)</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                class="form-control"
                [matTooltipDisabled]="!getPackageFormControlId(i, 'packageWidth').errors"
                matTooltip="{{ 'configuration.packageList.toolTip.minimumValidation' | translate }}"
                [ngStyle]="{
                  'border-color': getPackageFormControlId(i, 'packageWidth').errors ? 'red' : 'grey'
                }"
                min="0"
                maxlength="15"
                formControlName="packageWidth" />
            </td>
          </ng-container>

          <ng-container matColumnDef="Action">
            <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <button
                (click)="DeletePackageItem(pieces, i)"
                class="ml-2 secondary-btn"
                type="button">
                {{ 'global.delete' | translate }}
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr class="mat-row justify-content-center" *matNoDataRow>
            {{ 'global.noDataAvailable' | translate }}
          </tr>
        </table>
      </div>
    </ng-container>
  </div>
  <button
    [disabled]="!(this.packageDetails.valid && isValueChanged)"
    (click)="savePackageConfig()"
    class="ml-2 mt-2 primary-btn float-right"
    type="button">
    {{ 'global.save' | translate }}
  </button>
  <button (click)="AddNewPackageItem()" class="ml-2 mt-2 secondary-btn float-right" type="button">
    {{ 'global.addRow' | translate }}
  </button>
</div>
